import { PlatformAdminStubPage } from './PlatformAdminStubPage'

export function SignalProvidersStubPage() {
  return (
    <PlatformAdminStubPage
      title="Signal Providers"
      description="Manage verified Signal Providers across the platform."
      testId="platform-signal-providers-stub-page"
    />
  )
}

export function NotificationManagementStubPage() {
  return (
    <PlatformAdminStubPage
      title="Notification Management"
      description="Configure platform-wide notification templates and delivery settings."
      testId="platform-notification-management-stub-page"
    />
  )
}
